import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../components/Card";

const Contact = ({ isModal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    const backgroundLocation =
      location.state && location.state.backgroundLocation;
    if (backgroundLocation) {
      navigate(-1);
    } else {
      navigate("/profile");
    }
  };

  return (
    <div
      className={
        isModal
          ? "fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          : "min-h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100"
      }
    >
      <main
        className={
          isModal
            ? "w-full max-w-3xl p-4"
            : "w-full flex-grow flex items-center justify-center p-4 mt-16"
        }
      >
        <Card
          className={
            isModal
              ? "w-full rounded-2xl shadow-2xl"
              : "w-full max-w-3xl rounded-2xl shadow-2xl"
          }
        >
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-center bg-gradient-to-r from-[#cabb78] to-[#b5a666] bg-clip-text text-transparent">
              {t("contct")}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex justify-end">
              <button
                onClick={handleClose}
                className="px-3 py-1 rounded-md text-gray-700 hover:text-white hover:bg-[#b5a666] transition-colors"
                aria-label="Close"
              >
                ✕
              </button>
            </div>
            <div>
              <p className="text-gray-700">Kiinteistömittaus Oy</p>
              <p className="text-gray-600">info@kiinteistomittaus.fi</p>
              <p className="text-gray-600">+358407725456</p>
            </div>
            <div className="space-y-2">
              <a
                href="https://www.linkedin.com/in/kaarlohirvi/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#b5a666] hover:text-[#cabb78] transition-colors"
              >
                <svg
                  className="h-5 w-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
                LinkedIn
              </a>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default Contact;
